<template>
  <svg
    :height="height"
    viewBox="-35 0 512 512"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="color"
      d="m256 512c-68.375 0-132.652344-26.625-181.011719-74.988281-48.363281-48.359375-74.988281-112.636719-74.988281-181.011719 0-68.394531 26.625-132.671875 74.988281-181.035156 48.359375-48.363282 112.636719-74.964844 181.011719-74.964844s132.652344 26.625 181.011719 74.988281c4.160156 4.160157 4.160156 10.921875 0 15.082031-4.160157 4.160157-10.921875 4.160157-15.082031 0-44.328126-44.332031-103.253907-68.738281-165.929688-68.738281s-121.621094 24.40625-165.953125 68.738281c-44.328125 44.328126-68.714844 103.253907-68.714844 165.929688s24.40625 121.601562 68.738281 165.929688c44.328126 44.332031 103.253907 68.738281 165.929688 68.738281s121.621094-24.40625 165.953125-68.738281c4.160156-4.160157 10.921875-4.160157 15.082031 0 4.160156 4.160156 4.160156 10.921874 0 15.082031-48.363281 48.363281-112.660156 74.988281-181.035156 74.988281zm0 0"
    />
    <path
      :fill="color"
      d="m437.332031 106.667969h-85.332031c-5.886719 0-10.667969-4.78125-10.667969-10.667969s4.78125-10.667969 10.667969-10.667969h74.667969v-74.664062c0-5.890625 4.777343-10.667969 10.664062-10.667969 5.890625 0 10.667969 4.777344 10.667969 10.667969v85.332031c0 5.886719-4.777344 10.667969-10.667969 10.667969zm0 0"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#fff",
    },
    width: {
      type: String,
      default: "33",
    },
    height: {
      type: String,
      default: "33",
    },
  },
};
</script>

<style lang="scss" scoped>
</style>